export const fromUTCISOString = (isoString: string): Date => {
	const d = new Date(isoString)
	return new Date(
		d.getUTCFullYear(),
		d.getUTCMonth(),
		d.getUTCDate(),
		d.getUTCHours(),
		d.getUTCMinutes(),
		d.getUTCSeconds()
	)
}